import { getV2ApiCompanyIdCardsCardProductRegulatoryLimits } from 'src/client/spendesk-api';
import { logger } from 'src/utils/datadog-log-wrapper';

type CardProduct =
  | 'single_purchase'
  | 'subscription'
  | 'physical'
  | 'multi_use';

export type GetCardProductRegulatoryLimitsInput = {
  companyId: string;
  cardProduct: CardProduct;
};

type RegulatoryLimitIntervals =
  | 'LIFETIME'
  | 'MONTHLY'
  | 'PER_TRANSACTION'
  | 'WEEKLY'
  | 'QUARTERLY'
  | 'YEARLY';

export type CardProductRegulatoryLimits = {
  [interval in RegulatoryLimitIntervals]: number;
};

export type CardProductRegulatoryLimitsPerTransactionOrMonthly = Pick<
  CardProductRegulatoryLimits,
  'PER_TRANSACTION' | 'MONTHLY'
>;

export const getCardProductRegulatoryLimits = async ({
  cardProduct,
  companyId,
}: GetCardProductRegulatoryLimitsInput): Promise<CardProductRegulatoryLimits> => {
  const response = await getV2ApiCompanyIdCardsCardProductRegulatoryLimits({
    path: {
      companyId,
      cardProduct,
    },
  });
  if (response.statusCode !== 200) {
    logger.error('Failed to retrieve card product regulatory limits.', {
      error: response.body,
      scope: 'card-regulatory-limits',
      team: 'cards-ux',
    });
    throw new Error('Failed to retrieve card product regulatory limits.');
  }

  return response.body.data;
};
